import { render } from "./PickupReportModal.vue?vue&type=template&id=17212890"
import script from "./PickupReportModal.vue?vue&type=script&lang=js"
export * from "./PickupReportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__